import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from 'src/app/shared/services/webapi.service';
import { AppState } from 'src/app/store/app.states';
import { getUserInfo } from 'src/app/store/selector/selector';
import { take } from 'rxjs/operators';

declare var bootstrap: any;
declare var $: any;  

@Component({
  selector: 'app-submit-skill',
  templateUrl: './submit-skill.component.html',
  styleUrls: ['./submit-skill.component.scss']
})
export class SubmitSkillComponent implements OnInit {
  skillSubmitting=false;

  user:any
  skillForm: FormGroup = this.fb.group({
    // email: ['', Validators.compose([Validators.required, Validators.email])],
    // name: ['', Validators.compose([Validators.required])],
    // profession: ['', Validators.compose([Validators.required])],
    message: ['', Validators.compose([Validators.required])]
  }); 

  constructor(private fb: FormBuilder,private store: Store<AppState>, private toastrService: ToastrService, public webApi: WebapiService) {
  }

  ngOnInit()  
  {    
    setTimeout(()=>{
      this.getUserData()
    },1000)
  } 

  
  getUserData(){
    this.webApi.setLoader(true)

    this.store.pipe(select(getUserInfo),take(1)).subscribe(data=>{
      this.user = data
      this.webApi.setLoader(false)
    },error=>{
      this.webApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
    // this.webApi.getUserData().subscribe((data: any) => {
    //   if(data.success){
    //     this.user=data.data
    //   }else{
    //     this.toastrService.error(data.message);
    //   }
    // },
    // error => {
    //   this.toastrService.error("unable to handle response");
    // });
  }

  onSubmitSkill(form: FormGroup) {
    if (form.valid && !this.skillSubmitting) {
      this.skillSubmitting = true;
      this.webApi.skillSuggestion(form.value).subscribe((data: any) => {
        if (data.success) {
          form.reset();
					this.toastrService.success(data.message);
          $('#suggest-skill').modal('hide');
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.skillSubmitting = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.skillSubmitting=false;
      });
    } else {
      this.webApi.validateAllFields(form);
    }
  }

  get f2(): { [key: string]: AbstractControl } {
    return this.skillForm.controls;
  }
  
}
